var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ui-tabs-navigation"},[_c('div',{staticClass:"ui-tabs__nav",class:{
            'centered': _vm.centered,
            'vertical': _vm.vertical,
        }},_vm._l((_vm.items),function(item,index){return _c('button',{key:index,staticClass:"ui-tabs__nav-button",class:{
                'active': _vm.value === index,
                'opened': _vm.isOpened
            },domProps:{"innerHTML":_vm._s(item.label)},on:{"click":function($event){return _vm.changeTab(index)}}})}),0),_vm._v(" "),_c('div',{staticClass:"ui-tabs__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }